import { css } from "../../../styled-system/css";

export const MODULE_PADDING_MOBILE = "24px";
export const MODULE_PADDING_DESKTOP = "36px";
export const MODULE_PADDING_HEADER_MOBILE = "24px";
export const MODULE_PADDING_HEADER_DESKTOP = "36px";

export const styles = {
  root: css({
    "& .module": {
      "& .moduleWrapper": {
        background: "var(--primary-color)",
        padding: `${MODULE_PADDING_MOBILE} 0`,
        desktop: {
          padding: `${MODULE_PADDING_DESKTOP} 0`,
        },
      },
      "&:last-of-type": {
        "& .moduleWrapper": {
          background: "var(--last-module-color, var(--primary-color))",
        },
      },
      "&[data-no-padding]&[data-no-padding]": {
        "& .moduleWrapper": {
          background: "transparent",
          padding: "0",
          desktop: {
            padding: "0",
          },
        },
      },
    },
  }),
};
